import { motion } from "framer-motion";

const personas = [
    {
        role: "CFO",
        line: "Peer-driven, budget-guarding, ROI-hungry. Never clicks. Must be found.",
        img: "https://images.unsplash.com/photo-1560250097-0b93528c311a",
    },
    {
        role: "VP Finance",
        line: "The champion in the middle. Needs the business case in a box.",
        img: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e",
    },
    {
        role: "Controller",
        line: "Detail-obsessed. Front-line evaluator. Holds veto power on adoption.",
        img: "https://images.unsplash.com/photo-1580489944761-15a19d654956",
    },
    {
        role: "IT / Security",
        line: "The invisible evaluator. Late to the deal. Can kill it in one email.",
        img: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7",
    },
];

export default function Personas() {
    return (
        <section
            data-testid="personas-section"
            className="rule-top rule-bottom bg-[#0a0a0a]"
        >
            <div className="container-x py-24 md:py-32">
                <div className="mb-14 md:mb-20 max-w-3xl">
                    <span className="tag">The Buying Committee</span>
                    <h2 className="font-display uppercase text-white text-4xl md:text-6xl mt-4 leading-[0.95]">
                        You are not selling to one person.
                        <span className="font-editorial italic font-normal normal-case text-[#e84125] tracking-normal">
                            {" "}
                            You are selling to a committee.
                        </span>
                    </h2>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-4">
                    {personas.map((p, i) => (
                        <motion.div
                            key={p.role}
                            data-testid={`persona-${p.role.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: i * 0.1, duration: 0.7 }}
                            className="group relative overflow-hidden border border-white/5 bg-[#050505]"
                        >
                            <div className="relative aspect-[3/4] overflow-hidden">
                                <img
                                    src={p.img}
                                    alt={p.role}
                                    loading="lazy"
                                    className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
                                    style={{
                                        filter: "grayscale(1) contrast(1.1) brightness(0.6)",
                                    }}
                                />
                                <div
                                    className="absolute inset-0"
                                    style={{
                                        background:
                                            "linear-gradient(180deg, transparent 40%, rgba(5,5,5,0.95) 95%)",
                                    }}
                                />
                                <span className="absolute top-4 left-4 font-mono uppercase text-[0.65rem] tracking-[0.24em] text-[#e84125]">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                            </div>
                            <div className="p-5 md:p-6">
                                <h3 className="font-display uppercase text-white text-2xl mb-2">
                                    {p.role}
                                </h3>
                                <p className="font-body text-white/60 text-sm leading-relaxed">
                                    {p.line}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
